import {
  Tabs,
  Flex,
  ModalCustom,
} from "@components/index";

import EmptyFragment from "@fragments/Empty.fragment";
import TimesFragment from "@fragments/Times.fragment";
import StatusFragment from "@fragments/Status.fragment";
import NonExecutionButton from "./fragments/NonExecution";

import { formatDateUTCToTimeLocal } from "@utils/datetime";
import { useDetailsContext } from "@pages/Dashboard/contexts/Details.context";

import styles from "./Details.module.scss";

const Details: React.FC<React.PropsWithChildren> = () => {
  const { event, open, onClose } = useDetailsContext();

  const labels: Record<Sentinel.Enumerators.ProcessExecutionEventType, string> = {
    START: "Início da rodada",
    ERROR: "Erro da rodada",
    RESTART: "Reinício da rodada",
    FINISH: "Final da rodada",
    UNDEFINED: "",
  };

  return (
    <ModalCustom
      open={open}
      title={event?.displayName}
      onClose={onClose}
      header={
        <Flex className="pt-15">
          <StatusFragment status={event?.status} plannedExecutionStart={event?.plannedExecutionStart} />
        </Flex>
      }
    >
      <Tabs defaultActiveKey="1">
        <Tabs.Tab eventKey="1" title="Geral">
          <Flex.Col gap="15px" className="px-20 py-10">
            <h2 className={styles.title}>Tempo</h2>

            <TimesFragment
              gapCol="15px"
              gapRow="20px"
              plannedExecutionStart={event?.plannedExecutionStart}
              plannedExecutionEnd={event?.plannedExecutionEnd}
              executionStart={event?.executionStart}
              executionEnd={event?.executionEnd} />

            <h2 className={styles.title}>Informações</h2>

            <Flex.Col gap="4px">
              <span className={styles["info-label"]}>Descrição</span>
              <span className={styles["info-value"]}>
                {event?.description ?? "Descrição não informada"}
              </span>
            </Flex.Col>

            <Flex.Col gap="4px">
              <span className={styles["info-label"]}>Link Padrão</span>
              {event?.linkDocumentation
                ? (
                  <a
                    href={event.linkDocumentation}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["info-value"]}
                  >
                    {event.linkDocumentation}
                  </a>
                )
                : (
                  <span className={styles["info-value"]}>Sem link cadastrado</span>
                )
              }
            </Flex.Col>

            <NonExecutionButton
              event={event}
              onSuccess={onClose}
            />
          </Flex.Col>
        </Tabs.Tab>

        <Tabs.Tab eventKey="2" title="Histórico">
          <Flex.Col className="px-20 py-10" gap="10px">
            {event?.executionEvents?.map((item, index) => (
              <Flex.Row key={index} justifyContent="space-between">
                <span>{labels[item.eventType]}</span>
                <span>{formatDateUTCToTimeLocal(item.executionTime, "00:00")}</span>
              </Flex.Row>
            ))}
          </Flex.Col>

          <EmptyFragment show={!event?.executionEvents?.length} size="sm" className="pt-50">Sem dados</EmptyFragment>
        </Tabs.Tab>
      </Tabs>
    </ModalCustom>
  );
}

export default Details;
